<template>
  <div class="mt55">
    <div
      class="w1200"
      v-show="isShow"
    >
      <div class="head clearfix">
        <HT
          text="wflow"
          style="margin-top:0px;margin-left:-35px;float:left"
        />
        <div class="fr bread clearfix">
          <div
            class="fl"
            style="margin-right:15px;color: #064186"
          >
            当前位置:
          </div>
          <div class="fl">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">
                首页
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/warehouse/wconcept' }">
                医药共享仓
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/warehouse/wflow' }">
                运作流程
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>
      <div class="content" />
    </div>
  </div>
</template>

<script>
import HT from '@/components/h2.vue'



export default {
    data() {
        return {
            list: [],
            isShow: true
        }
    },
    components: {
        HT
    }
}
</script>
<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .content{
        width: 1200px;
        margin:0 auto;
        height: 700px;
        /* background: url('../../../assets/images/zzjg.jpg') center 100px no-repeat; */
    }
</style>

<style>
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
</style>